import { inject, Injectable } from '@angular/core';
import { IPlace } from '@okcargo-apps/shared-domain-ionic';
import { PlaceQueryService } from '@okcargo-apps/shared-infrastructure-ionic';
import { SearchPlacesQuery } from '@okcargo/query-processor';

@Injectable({
  providedIn: 'root',
})
export class PlaceService {
  private readonly addressQueryService = inject(PlaceQueryService);

  public async searchPlaces(term: string, countryCode = 'ES', abortSignal?: AbortSignal): Promise<IPlace[]> {
    if (!term || term.trim().length < 2) {
      return [];
    }

    const query: SearchPlacesQuery = {
      countryCode: countryCode,
      city: term.trim(),
      postalCode: term.trim(),
    };

    // TODO review, use SearchOptions???
    const queryWithSignal = {
      ...query,
      ...(abortSignal && { abortSignal }),
    } as SearchPlacesQuery;

    try {
      return await this.addressQueryService.searchPlaces(queryWithSignal);
    } catch (error: any) {
      if (error?.name === 'AbortError') {
        return [];
      }
      console.error('Error en PlaceService:', error);
      return [];
    }
  }
}
